import TextField from '@app/src/components/Ui/TextField'
import type { AnswerFlagFormData } from '@app/src/pages/Configurations/ConfigurationsPages/AnswerFlag/CreateAnswerFlagModal'
import { ANSWER_FLAG_FORM_KEYS } from '@app/src/pages/Configurations/ConfigurationsPages/AnswerFlag/CreateAnswerFlagModal'
import { Typography } from '@mui/material'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'

const AnswerFlagTitle: React.FC = () => {
  const { formatMessage } = useIntl()
  const { control } = useFormContext<AnswerFlagFormData>()

  return (
    <>
      <Typography variant="body2" gutterBottom>
        {formatMessage({ id: 'answerFlagRules.creation.answerFlagTitle.label' })}
      </Typography>
      <Controller
        name={ANSWER_FLAG_FORM_KEYS.DESCRIPTION}
        control={control}
        render={({ onChange, value }) => (
          <TextField
            variant="filled"
            fullWidth
            value={value ?? ''}
            onChange={e => onChange(e.target.value)}
            placeholder={formatMessage({ id: 'answerFlagRules.creation.answerFlagTitle.placeholder' })}
          />
        )}
      />
    </>
  )
}

export default AnswerFlagTitle
